import { Tabs, TabsList, TabsTrigger, TabsContent } from '@/components/ui/tabs';
import { ReceitasTable } from './ReceitasTable';
import type { Ris, Ric } from '@/services/SimplesNacional/Segregacao/api/types';

interface ReceitaInternaTabsProps {
  ris: Ris[];
  ric: Ric[];
  onClickLinha?: (linha: string) => void;
}

export function ReceitaInternaTabs({ ris, ric, onClickLinha }: ReceitaInternaTabsProps) {
  return (
    <Tabs defaultValue="sem-st">
      <TabsList>
        <TabsTrigger value="sem-st">Sem Substituição Tributária</TabsTrigger>
        <TabsTrigger value="com-st">Com Substituição Tributária</TabsTrigger>
      </TabsList>
      <TabsContent value="sem-st">
        <ReceitasTable data={ris} onClickLinha={onClickLinha} />
      </TabsContent>
      <TabsContent value="com-st">
        <ReceitasTable data={ric} onClickLinha={onClickLinha} />
      </TabsContent>
    </Tabs>
  );
}
